export enum  SlcServiceCookMappingEnum {
    PRIMARY = "PRIMARY",
    SECONDARY = "SECONDARY"
}